/**
 * The "Update operational hours" template: the header the API checks
 * (uniliveapi `OperationalTimeImportService::HEADERS`) and one example screen, Monday to Sunday,
 * in the shape of the media-owner files ops already use. Column names are the API's, not copy.
 */
export const OPERATIONAL_HOURS_HEADER = [
    'type',
    'day',
    'date',
    'start_time',
    'end_time',
    'operationalTiming_id',
    'operationalTiming_type',
    'created_at',
    'updated_at',
    'deleted_at',
] as const;

export const OPERATIONAL_HOURS_TEMPLATE_FILENAME = 'operational_hours_template.csv';

const EXAMPLE_SCREEN_ID = 12345;

// Weekdays close at midnight (00:00:00); Sunday shows shorter hours.
const exampleDays: [day: string, start: string, end: string][] = [
    ['Monday', '05:00:00', '00:00:00'],
    ['Tuesday', '05:00:00', '00:00:00'],
    ['Wednesday', '05:00:00', '00:00:00'],
    ['Thursday', '05:00:00', '00:00:00'],
    ['Friday', '05:00:00', '00:00:00'],
    ['Saturday', '06:00:00', '00:00:00'],
    ['Sunday', '08:00:00', '18:00:00'],
];

// One line per row, each ending in a newline (so the file ends with one).
export const buildOperationalHoursTemplate = (): string =>
    [
        OPERATIONAL_HOURS_HEADER.join(','),
        ...exampleDays.map(([day, start, end]) =>
            ['recurring', day, '', start, end, EXAMPLE_SCREEN_ID, 'Displays', '', '', ''].join(','),
        ),
    ]
        .map(line => `${line}\n`)
        .join('');
